import { Notice, Text } from "@sundae/ui-toolkit";
import { TNotice } from "@sundae/ui-toolkit/dist/types/components/molecules/Notice/Notice";
import { FC, PropsWithChildren, memo, useMemo } from "react";
import TransWithCardanoRegistryLink from "../../i18n/components/warnings/WarningWithCardanoRegistryLink/TransWithCardanoRegistryLink.trans";

export type TWarning = TNotice & {
  context?: string;
  extendedWarning?: boolean;
  i18nFields?: { [i18nField: string]: unknown };
  warning?: string;
};

const Warning: FC<PropsWithChildren<TWarning>> = memo(
  ({
    children,
    context,
    extendedWarning,
    i18nFields,
    type = "warning",
    warning,
    showErrorFlash,
    isConsentChecked,
    withConsent,
    title,
    onConsentChange,
  }) => {
    const textVariant = useMemo(() => {
      if (showErrorFlash) return "error";
      if (isConsentChecked) return "success";

      return type;
    }, [isConsentChecked, showErrorFlash]);

    return (
      // @ts-ignore
      <Notice
        className="motion-safe:animate-dialog-overlay-show"
        type={type}
        title={title}
        {...(withConsent && {
          withConsent: true,
          showErrorFlash,
          isConsentChecked,
          onConsentChange,
        })}
      >
        <Text size="xs" tag="div" variant={textVariant}>
          {children ?? (
            <TransWithCardanoRegistryLink
              i18nKey={`warning.${warning}`}
              ns="warnings"
              {...i18nFields}
              {...(extendedWarning && { context: "extended" })}
              {...(context && { context })}
            />
          )}
        </Text>
      </Notice>
    );
  }
);

export default Warning;
